import { render, staticRenderFns } from "./increaseInner.vue?vue&type=template&id=4876088c&scoped=true&"
import script from "./increaseInner.vue?vue&type=script&lang=js&"
export * from "./increaseInner.vue?vue&type=script&lang=js&"
import style0 from "./increaseInner.vue?vue&type=style&index=0&id=4876088c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4876088c",
  null
  
)

export default component.exports